import { useAtomValue } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'
import { useLogEvent } from '~/hooks/useLogEvent'

import { dialogInfoAtom } from '../atoms'
import { useCloneCustomerAttributeMutation } from '../hooks/useCloneCustomerAttributeMutation'
import { useCloseDialogWithRefresh } from '../hooks/useCloseDialogWithRefresh'

export const CloneCustomerAttributeDialog = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)
  if (dialogInfo?.dialogType !== 'clone') {
    throw new Error()
  }
  const { customerAttribute } = dialogInfo

  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  const closeDialogWithRefresh = useCloseDialogWithRefresh()
  const logEvent = useLogEvent()

  const cloneCustomerAttributeGroupMutation = useCloneCustomerAttributeMutation(
    {
      onSuccess: () => {
        closeDialogWithRefresh()
        logEvent('Clone customer attribute')
      },
    },
  )
  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    cloneCustomerAttributeGroupMutation.mutate(customerAttribute.id)
  }, [customerAttribute.id, cloneCustomerAttributeGroupMutation])
  const { t } = useTranslation()

  return (
    <ExecuteCancelDialog
      executing={cloneCustomerAttributeGroupMutation.isPending}
      mode="duplicate"
      title={t('duplicate_custom_segment_1')}
      onCancel={resetDialogInfo}
      onExecute={handleExecute}
    >
      {t('confirm_duplicate_custom_segment', {
        segmentName: customerAttribute.name,
      })}
    </ExecuteCancelDialog>
  )
}
